function _interopDefault(ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var reactIcons = require('react-icons');

var getIndexOfSecondUppercaseChar = function getIndexOfSecondUppercaseChar(text) {
  var index = 0;
  var numberOfUppercaseChars = 0;

  while (index <= text.length) {
    if (text.charAt(index) === text.charAt(index).toUpperCase()) {
      numberOfUppercaseChars = numberOfUppercaseChars + 1;
    }

    if (numberOfUppercaseChars === 2) {
      break;
    }

    index = index + 1;
  }

  return index;
};

var loadIcons = function loadIcons(name) {
  var index = getIndexOfSecondUppercaseChar(name);
  if (index === name.length) return null;
  var iconLib = name.substring(0, index).toLowerCase();

  switch (iconLib) {
    // case 'ai':
    //   return require('react-icons/ai');
    // case 'bs':
    //   return require('react-icons/bs');
    // case 'di':
    //   return require('react-icons/di');
    // case 'fa':
    //   return require('react-icons/fa');
    // case 'fc':
    //   return require('react-icons/fc');
    // case 'fi':
    //   return require('react-icons/fi');
    // case 'gi':
    //   return require('react-icons/gi');
    // case 'go':
    //   return require('react-icons/go');
    // case 'gr':
    //   return require('react-icons/gr');
    // case 'io':
    //   return require('react-icons/io');
    // case 'md':
    //   return require('react-icons/md');
    // case 'ri':
    //   return require('react-icons/ri');
    // case 'ti':
    //   return require('react-icons/ti');
    // case 'wi':
    //   return require('react-icons/wi');
    // case 'io5':
    //   return require('react-icons/io5');
    case 'hi':
      return require('react-icons/hi/index');
    // case 'si':
    //   return require('react-icons/si');
    // case 'im':
    //   return require('react-icons/im');
    // case 'bi':
    //   return require('react-icons/bi');
    // case 'cg':
    //   return require('react-icons/cg');
    // case 'cg':
    //   return require('react-icons/cg');

    default:
      return null;
  }
};

var getIcon = function getIcon(name) {
  var icons = loadIcons(name);
  if (!icons) return null;
  return icons[name];
};

var Icon = function Icon(_ref) {
  var name = _ref.name,
    color = _ref.color,
    size = _ref.size,
    className = _ref.className,
    style = _ref.style;
  var Icon = name ? getIcon(name) : null;
  return /*#__PURE__*/React.createElement(reactIcons.IconContext.Provider, {
    value: {
      color: color,
      size: size,
      className: className,
      style: style
    }
  }, name && Icon && /*#__PURE__*/React.createElement(Icon, null));
};

module.exports = Icon;
